var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPenIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.976,
    height: 15.273,
    viewBox: "0 0 14.976 15.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11469",
    "data-name": "Group 11469",
    transform: "translate(-42.308 -57.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29601",
    "data-name": "Path 29601",
    d: "M5033.248,165l-8.623,8.417-1.407,5.455,4.786-1.161,8.807-8.789Z",
    transform: "translate(-4980.218 -106.366)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29602",
    "data-name": "Path 29602",
    d: "M4561.863,108.129l3.583,4.2",
    transform: "translate(-4517.456 -41.092)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIcon2);
export default __webpack_public_path__ + "static/media/PenIcon2.d33d5d77cb12947157feb3a1d0fa6ffa.svg";
export { ForwardRef as ReactComponent };